import '../theme/fonts';
import '../theme/tokens.css';
import '../theme/base.css';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import type { PageKey } from './head';
import { PAGE_COMPONENTS } from './pages';
import { loadHubSpotTracking } from './tracking';

/**
 * The public pages' client entry: hydrates the prerendered page named by <div id="root" data-page>, so the islands
 * (header menu, fit check, contact form, copy button) become interactive. It loads neither supabase-js nor the portal
 * router.
 */
document.documentElement.classList.add('js');

const root = document.getElementById('root')!;
const Page = PAGE_COMPONENTS[root.dataset.page as PageKey];
if (Page) {
  hydrateRoot(
    root,
    <StrictMode>
      <Page />
    </StrictMode>,
  );
}

loadHubSpotTracking();
